import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  RowSelectingEventArgs,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';
import {
  addFethSize,
  deleteFethSize,
  getFethSize,
  updateFethSize
} from '../../../services/SystemSettings/SystemSettingsService';
import { BsCheck2 } from 'react-icons/bs';
import { BiX } from 'react-icons/bi';
import Message from '../../../utils/Message/Message';

interface IState {
  configData: any;
}
interface IProps { }

export class SystemSettings extends Component<IProps, IState> {
  private grid: any;
  private switchStatus: SwitchComponent = new SwitchComponent({});
  public validationRule: Object = { required: true };
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      configData: [],
    };
  }

  componentDidMount() {
    this.getData();
  }
  getData = async () => {
    const model = await getFethSize();
    this.setState({ configData: model.data });
  }

  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getData();
      this.grid.refresh()
    }
  }

  actionBeginComponent(args: any) {
    args.data = {
      ...args.data,
      isChecked: this.switchStatus?.checked,
    };

    if (args.action === 'add') {
      if (this.state.configData.length <= 4) {
        console.log(args.data.fetch_size)
        console.log(typeof args.data.fetch_size)


        let typeFetchSize = args.data.fetch_size ? typeof parseInt(args.data.fetch_size) : typeof args.data.fetch_size ;
        if (typeFetchSize == 'number') {
          if (args.data.fetch_size > 0) {
            if (this.state.configData.includes(args.data?.fetch_size)) {
              this.getData()
              Message.error(`The fetch size ${args.data.fetch_size} is already exist...`)
            }
            else {
              addFethSize(args.data).then((result: any) => {
                this.grid.showSpinner();
                if (result.status === 201) {
                  this.getData().then((result: any) => {
                    if (result.status === 200) {
                      this.grid.refresh();
                    }
                  }).catch((err) => { });
                }
              }).catch((err) => {
                this.getData()
                Message.error(`The fetch size ${args.data.fetch_size} is already exist...`)
              });
            }
          }
          else {
            this.getData()
            Message.error("Fetch size can not be negative or zero...")
          }
        }
        else {
          this.getData()
          if (args.data.fetch_size === undefined) {
            console.log(args.data.fetch_size)

            Message.error("Fetch size can not be empty...")
          } else {
            console.log(args.data.fetch_size)
            Message.error("Fetch size must be a number...")
          }
        }
      }
      else {
        this.getData()
        Message.error("Can not add more than five datas...")
      }
    }
    else if (args.action === 'edit') {
      if (typeof args.data.fetch_size === 'number') {
        if (args.data.fetch_size >= 0) {
          if (this.state.configData.includes(args.data?.fetch_size)) {
            this.getData()
            this.grid.refresh();
          }
          else {
            updateFethSize(args.data).then((result: any) => {
              this.grid.showSpinner();
              if (result.status === 200) {
                this.getData().then((result: any) => {
                  if (result.status === 200) {
                    this.grid.refresh();
                  }
                }).catch((err) => {
                  this.grid.refresh();
                });
              }
            }).catch((err) => {
              this.getData()
            });
          }
        }
        else {
          Message.error("Fetch size can not be negative...")
          this.grid.refresh();
        }
      }
      else {
        this.getData()
        if (args.fetch_size === undefined) {
          Message.error("Invalid fetch size...")
          this.grid.refresh();
        } else {
          Message.error("Invalid fetch size...")
          this.grid.refresh();
        }
      }
    }
    else if (args.requestType === 'delete') {
      deleteFethSize(args.data[0]).then((result: any) => {
        this.grid.showSpinner();
        if (result.status == 200) {
          this.getData().then((result: any) => {
            if (result.status == 200) {
              this.grid.refresh();
            }
          }).catch((err) => { });
        }
      }).catch((err) => { });
    }
  }
  private istatustemplate(args: any) {
    let isChecked = args.isChecked;
    return (
      <div>
        {isChecked ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }

  private isStatustemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.isChecked}
        ref={(scope: SwitchComponent) => (this.switchStatus = scope)}
      />
    );
  }
  public rowSelecting = (args: RowSelectingEventArgs) => {
    if (args.target && args.target.classList.contains('e-icons')) {
      (this.grid as GridComponent).clearSelection();
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridAC'
          editSettings={this.editOptions}
          ref={(g) => (this.grid = g)}
          toolbar={this.toolbarOptions}
          dataSource={this.state.configData}
          height='calc(-220px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginComponent.bind(this)}
          gridLines='Both'
          selectionSettings={{
            type: 'Single', checkboxMode: 'ResetOnRowClick',
          }}
          rowSelecting={this.rowSelecting}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='id'
              headerText='Id'
              visible={false}
            />
            <ColumnDirective
              field='fetch_size'
              headerText='Fetch Size'
            />
            <ColumnDirective
              field='isChecked'
              headerText='Applied'
              textAlign='Left'
              template={this.istatustemplate.bind(this)}
              editTemplate={this.isStatustemplateEditing.bind(this)}
              width={'30px'}
              minWidth={'30px'}
              allowEditing={false}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default SystemSettings;
